import {
  Nav,
  NavItem,
  NavLink
} from 'reactstrap'
import './index.css'

const PillNavigation = ({ navList, active, toggle }: { navList: any[], active: number, toggle: (tab: number) => void }) => {
  return (
    <Nav pills className="subnavbarwholephillstyle">
      {navList.map((item: any, index: any) => {
        return (
          <NavItem key={item.id}>
            <NavLink
              active={active === item.id}
              onClick={() => {
                toggle(item.id);
              }}
              className="subnavbarlinkstextcolor"
            >
              {item.item}
            </NavLink>
          </NavItem>
        );
      })}
    </Nav>
  );
}

export default PillNavigation;